module.exports = __webpack_public_path__ + "images/backgrounds/mountain/full.171b0c9aea08e21f0020.jpg";